import Cookies from 'js-cookie';

const JIVO_WIDGET_ID = 'GBeMVuWTJ8';
const JIVO_SCRIPT_ID = 'jivo-site-widget-script';
const JIVO_SCRIPT_SRC = `https://code.jivo.ru/widget/${JIVO_WIDGET_ID}`;

const COOKIE_CONSENT = 'cookie_consent';
const COOKIE_CONSENT_MAX_AGE_DAYS = 3650;

const JIVO_STORAGE_PREFIXES = ['jv_', 'jivo'];

export enum CookieConsentValue {
    all = 'all',
    necessary = 'necessary',
}

export const getCookieConsent = (): CookieConsentValue | null => {
    const value = Cookies.get(COOKIE_CONSENT);

    if (value === CookieConsentValue.all || value === CookieConsentValue.necessary) {
        return value;
    }

    return null;
};

export const setCookieConsent = (value: CookieConsentValue): void => {
    Cookies.set(COOKIE_CONSENT, value, {
        expires: COOKIE_CONSENT_MAX_AGE_DAYS,
        sameSite: 'Lax',
    });
};

export const isCookieConsentEnabled = (): boolean => {
    if (typeof window === 'undefined') return false;

    return process.env.NEXT_PUBLIC_PROJECT_NAME === 'epn';
};

const removeCookieByName = (name: string): void => {
    const hostnameParts = window.location.hostname.split('.');
    const rootDomain =
        hostnameParts.length >= 2 ? `.${hostnameParts.slice(-2).join('.')}` : undefined;

    document.cookie = `${name}=; Max-Age=0; path=/`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname}`;

    if (rootDomain) {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${rootDomain}`;
    }
};

export const clearJivoStorage = (): void => {
    if (typeof window === 'undefined') return;

    const shouldRemoveKey = (key: string): boolean =>
        JIVO_STORAGE_PREFIXES.some(prefix => key.toLowerCase().startsWith(prefix));

    document.cookie
        .split(';')
        .map(cookieItem => cookieItem.trim().split('=')[0])
        .filter(Boolean)
        .filter(shouldRemoveKey)
        .forEach(removeCookieByName);

    [window.localStorage, window.sessionStorage].forEach(storage => {
        Object.keys(storage)
            .filter(shouldRemoveKey)
            .forEach(key => storage.removeItem(key));
    });
};

export const loadJivoScript = (): void => {
    if (typeof window === 'undefined') return;

    if (document.getElementById(JIVO_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = JIVO_SCRIPT_ID;
    script.src = JIVO_SCRIPT_SRC;
    script.async = true;

    document.body.append(script);
};
